import { useQuery } from '@tanstack/react-query';
import { getMe } from '../api/auth-api';

/**
 * useMe — React Query hook for the current logged-in user's profile.
 * Returns the user's name, email, phone, and studentProfile (with college + yearOfStudy).
 *
 * Backend response shape: { success: true, data: { id, name, email, phone, studentProfile: { yearOfStudy, college: { name } } } }
 * We return the `data` field (the user object) directly.
 *
 * Falls back to the user object cached in localStorage (stored at login) as
 * initialData so the UI never shows blank fields while the request is in-flight
 * or if the network call fails.
 */
export const useMe = () => {
  return useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      // getMe() returns response.data = { success, data: { ...user } }
      const res = await getMe();
      return res.data; // this is the actual user object
    },
    staleTime: 4 * 60 * 1000, // 4 minutes
    retry: 1,
  });
};
